import { render, staticRenderFns } from "./FormationsItemBar.vue?vue&type=template&id=29e2cb56&"
import script from "./FormationsItemBar.vue?vue&type=script&lang=js&"
export * from "./FormationsItemBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports